module.exports = __webpack_public_path__ + "img/logo.b606ee59.svg";